import { useState, useEffect } from 'react';
import { AlloyButton } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { actions } from './actions';
import styles from '../ProductFitment.module.scss';
import cx from 'classnames';
import useEquipmentDrawer from '@app/hooks/useEquipmentDrawer';

const WillItFit = () => {
  const [t] = useTranslation();
  const {
    openAddDrawer,
    openEditDrawer,
    openSelectDrawer,
    getDrawerComponent
  } = useEquipmentDrawer();
  const buttonTitle = t('MEQ_FITEMENT_COMPONENT_CTA1');
  const { ADD_EQUIPMENT, ADD_SERIAL_NUMBER, SELECT_EQUIPMENT } = actions;

  const [option, setOption] = useState();
  // ** useActions is used to bind Dispatch to actions creators. These are required by AddEquipment, EditEquipment and SelectEquipment *//
  const equipmentList = useSelector(
    s => s.myEquipment?.equipments?.myEquipmentList
  );
  const selectedEquipment = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment
  );
  const hasUserStoredEquipments =
    (Array.isArray(equipmentList) && equipmentList.length > 0) || false;
  const isEquipmentSelected = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.model
  );

  const renderOptions = {
    [ADD_EQUIPMENT]: {
      onClick: openAddDrawer,
      message: t('MEQ_PDP_FITMENT_CTA3')
    },
    [ADD_SERIAL_NUMBER]: {
      onClick: openEditDrawer,
      message: t('MEQ_FITEMENT_COMPONENT_CTA2')
    },
    [SELECT_EQUIPMENT]: {
      onClick: openSelectDrawer,
      message: t('MEQ_PDP_FITMENT_CTA2')
    }
  };

  useEffect(() => {
    if (isEquipmentSelected) {
      setOption(ADD_SERIAL_NUMBER);
    } else if (hasUserStoredEquipments) {
      setOption(SELECT_EQUIPMENT);
    } else {
      setOption(ADD_EQUIPMENT);
    }
  }, [
    ADD_EQUIPMENT,
    ADD_SERIAL_NUMBER,
    SELECT_EQUIPMENT,
    hasUserStoredEquipments,
    isEquipmentSelected
  ]);

  const { message, onClick } = renderOptions[option] || {};

  return (
    <>
      <AlloyButton
        buttonType="ghost"
        className={`px-0 py-0 text-start d-flex flex-column ${styles['glow-on-hover']}`}
        title={buttonTitle}
        onClick={onClick}
      >
        <span
          className={cx(
            'h4',
            'mb-1',
            'u-color--MediumBlue',
            styles['buttonTitle']
          )}
        >
          {buttonTitle}
        </span>

        <span
          className={cx(
            'text-xs',
            'text-sans-serif',
            'u-color--DarkGray',
            styles['text-transform-none']
          )}
        >
          {message}
        </span>
      </AlloyButton>
      {getDrawerComponent({
        currentEquipment: selectedEquipment,
        myEquipmentList: equipmentList
      })}
    </>
  );
};

export default WillItFit;
